import React, { useState } from 'react';
const faqs = [{
  q: 'Is this a physical book?',
  a: 'No. This is a PDF ebook delivered instantly to your inbox after purchase. No shipping, no waiting.'
}, {
  q: 'How do I receive it?',
  a: "Immediately after checkout, you'll receive an email with your download link. Access it within 60 seconds."
}, {
  q: 'Can I read it on my phone, iPad, or Kindle?',
  a: 'Yes. The PDF is optimized for all devices including iPhone, Android, iPad, and e-readers.'
}, {
  q: 'Is this news reporting?',
  a: 'This work presents investigative analysis and documented perspective for informational and educational purposes.'
}, {
  q: 'What is the refund policy?',
  a: "14-day money-back guarantee. If you're not satisfied, email us for a full refund. No questions asked."
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-editorial-bg py-section-mobile md:py-section-desktop px-6 md:px-8 border-t border-editorial-divider bg-gradient-to-b from-editorial-bgAlt to-editorial-bg" data-id="element-36">
      <div className="max-w-3xl mx-auto" data-id="element-37">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-editorial-text text-center mb-12" data-id="element-38">
          Common Questions
        </h2>

        <div className="w-full border-t border-editorial-divider" data-id="element-39">
          {faqs.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return <div key={idx} className="border-b border-editorial-divider" data-id="element-40">
                <button onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" aria-expanded={isOpen} data-id="element-41">
                  <span className="font-sans font-medium text-lg text-editorial-text pr-8 group-hover:text-editorial-accent transition-colors" data-id="element-42">
                    {faq.q}
                  </span>
                  <span className="text-editorial-accent text-2xl font-light shrink-0 transition-transform duration-300" data-id="element-43">
                    {isOpen ? '−' : '+'}
                  </span>
                </button>

                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 opacity-100 pb-6' : 'max-h-0 opacity-0'}`} data-id="element-44">
                  <p className="font-sans text-base text-editorial-textMuted leading-relaxed" data-id="element-45">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}